import React, { useRef, useState } from "react";

import brand1 from "assets/img/brand/5/brand-1.png";
import brand2 from "assets/img/brand/5/brand-2.png";
import brand3 from "assets/img/brand/5/brand-3.png";
import brand4 from "assets/img/brand/5/brand-4.png";
import brand5 from "assets/img/brand/5/brand-5.png";
import brand6 from "assets/img/brand/5/brand-6.png";
import brand7 from "assets/img/brand/5/brand-7.png";
import brand8 from "assets/img/brand/5/brand-8.png";

const brandLogos = [
  { src: brand1, alt: "Partner brand logo" },
  { src: brand2, alt: "Partner brand logo" },
  { src: brand3, alt: "Partner brand logo" },
  { src: brand4, alt: "Partner brand logo" },
  { src: brand5, alt: "Partner brand logo" },
  { src: brand6, alt: "Partner brand logo" },
  { src: brand7, alt: "Partner brand logo" },
  { src: brand8, alt: "Partner brand logo" },
];

const HomeTrustedBrands = () => {
  const marqueeRef = useRef(null);
  const trackRef = useRef(null);
  const dragStartRef = useRef({ x: 0, offset: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState(0);
  const marqueeLogos = [0, 1, 2].flatMap(() => brandLogos);

  const normalizeOffset = (offset) => {
    const track = trackRef.current;
    const cycleWidth = track ? track.scrollWidth / 3 : 0;

    if (!cycleWidth) return offset;

    const normalized = ((offset % cycleWidth) + cycleWidth) % cycleWidth;
    return normalized === 0 ? 0 : normalized - cycleWidth;
  };

  const handlePointerDown = (event) => {
    const marquee = marqueeRef.current;
    if (!marquee) return;

    setIsDragging(true);
    dragStartRef.current = {
      x: event.clientX,
      offset: dragOffset,
    };
    marquee.setPointerCapture(event.pointerId);
  };

  const handlePointerMove = (event) => {
    const marquee = marqueeRef.current;
    if (!isDragging || !marquee) return;

    event.preventDefault();
    const dragDistance = event.clientX - dragStartRef.current.x;
    setDragOffset(normalizeOffset(dragStartRef.current.offset + dragDistance));
  };

  const stopDragging = (event) => {
    const marquee = marqueeRef.current;
    setIsDragging(false);

    if (marquee?.hasPointerCapture?.(event.pointerId)) {
      marquee.releasePointerCapture(event.pointerId);
    }
  };

  return (
    <section className="trusted-brands__area">
      <div className="container">
        <div className="trusted-brands__heading text-center">
          <span>Trusted Collaborations</span>
          <h3>Brands We Have Worked With</h3>
        </div>
      </div>

      <div
        ref={marqueeRef}
        className={`trusted-brands__marquee${isDragging ? " is-dragging" : ""}`}
        aria-label="Brands we have worked with"
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
        onPointerUp={stopDragging}
        onPointerCancel={stopDragging}
        onPointerLeave={isDragging ? stopDragging : undefined}
      >
        <div
          ref={trackRef}
          className="trusted-brands__track"
          style={{ "--trusted-brands-drag-offset": `${dragOffset}px` }}
        >
          {marqueeLogos.map((logo, index) => (
            <div className="trusted-brands__item" key={`${logo.alt}-${index}`}>
              <img src={logo.src} alt={logo.alt} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeTrustedBrands;
